export default __webpack_public_path__ + "static/media/README.363c079a.md";